var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "contract" },
    [
      _c("section-title", {
        staticClass: "mt-4 mb-3",
        attrs: {
          "has-line": "",
          title: "Documentos de Contratación",
          "title-class": "section-title-info"
        }
      }),
      _vm._l(_vm.filteredDocuments, function(document, idx) {
        return _c("div", { key: idx }, [
          _c(
            "div",
            {
              staticClass:
                "document__container bg-medium-gray row justify-content-between align-items-center rounded mx-1 mb-4 p-3"
            },
            [
              _c("div", { staticClass: "col-12 col-md-3" }, [
                _c("span", { staticClass: "text-gray" }, [
                  _vm._v("Documento:")
                ]),
                _c("p", { staticClass: "content bold" }, [
                  _vm._v(_vm._s(document.name))
                ])
              ]),
              document.requireDate
                ? _c("div", { staticClass: "col-3 flex flex-column" }, [
                    _c("span", { staticClass: "text-gray" }, [
                      _vm._v("Fecha:")
                    ]),
                    _c(
                      "p",
                      { staticClass: "content" },
                      [
                        _c("custom-date-picker", {
                          staticClass: "custom-datetime-picker-container",
                          attrs: { placeholder: "DD/MM/YYYY" },
                          model: {
                            value: document.date,
                            callback: function($$v) {
                              _vm.$set(document, "date", $$v)
                            },
                            expression: "document.date"
                          }
                        })
                      ],
                      1
                    )
                  ])
                : _vm._e(),
              _c("div", { staticClass: "col-2 h-100 row align-items-center" }, [
                _c(
                  "div",
                  [
                    document.date
                      ? _c("action-button", {
                          staticClass: "d-inline",
                          attrs: {
                            i: "fas fa-file-signature",
                            text: "Descargar para firma",
                            variant: "outline-success"
                          },
                          on: {
                            click: function($event) {
                              return _vm.downloadDocument(document)
                            }
                          }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ]),
              _c("div", { staticClass: "col-4 row" }, [
                document.attachment || document.attachmentId
                  ? _c("div", { staticClass: "flex flex-column" }, [
                      _c("span", { staticClass: "text-gray" }, [
                        _vm._v("Nombre de Archivo:")
                      ]),
                      _c("p", [_vm._v(_vm._s(document.attachmentName))])
                    ])
                  : _vm._e(),
                _c(
                  "div",
                  {
                    staticClass: "document-info__description__actions ml-auto"
                  },
                  [
                    document.attachment || document.attachmentId
                      ? _c("action-button", {
                          staticClass: "mr-2 px-3 py-2 show-icon",
                          attrs: {
                            i: "fas fa-file-download",
                            variant: "success"
                          },
                          on: {
                            click: function($event) {
                              return _vm.downloadSignedDocument(document)
                            }
                          }
                        })
                      : _vm._e(),
                    document.attachment || document.attachmentId
                      ? _c("action-button", {
                          staticClass: "mr-2 px-3 py-2 show-icon",
                          attrs: {
                            i: "fas fa-times-circle",
                            variant: "outline-danger"
                          },
                          on: {
                            click: function($event) {
                              return _vm.removeFile(document)
                            }
                          }
                        })
                      : _vm._e(),
                    _c("custom-file-input", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !document.attachment && !document.attachmentId,
                          expression:
                            "!document.attachment && !document.attachmentId"
                        }
                      ],
                      ref: `fileUpload-${document.typeId}`,
                      refInFor: true,
                      staticClass: "custom-upload-document",
                      attrs: {
                        accept: ".pdf",
                        "attachment-id": document.attachmentId,
                        "display-style": "normal",
                        "max-size": 100,
                        name: document.attachmentName
                      },
                      on: {
                        input: function($event) {
                          return _vm.onUploadDocument($event, document.typeId)
                        }
                      },
                      model: {
                        value: document.attachment,
                        callback: function($$v) {
                          _vm.$set(document, "attachment", $$v)
                        },
                        expression: "document.attachment"
                      }
                    })
                  ],
                  1
                )
              ])
            ]
          )
        ])
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }